import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext();
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null); // ➡️ State to store user role
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Track errors

  const login = async (employeeId, password) => {
    try {
      setError(null);
      setLoading(true);
      const response = await axios.post(
        `${BASE_URL}/login`,
        { employeeId, password },
        { withCredentials: true }
      );

      // if (response.status === 200) {
      //   // console.log("Login successful:", response.data); // ✅ Debugging
      console.log("Login Response:", response.data);
      if (response.status === 200) {
        console.log("Saving Society Name:", response.data.SocietyName);

        localStorage.setItem("societyName", response.data.SocietyName);
        localStorage.setItem("societyPhoto", response.data.SocietyPhoto);
        localStorage.setItem("societyId", response.data.SocietyId);
        localStorage.setItem("userId", response.data.UserId);

        setIsAuthenticated(true);
        return response.data;
      }

      setIsAuthenticated(true);
      return response.data; // ✅ Ensure correct return value

    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
      setIsAuthenticated(false);
      // setUserRole(null);
      // sessionStorage.removeItem("isAuthenticated");
      // sessionStorage.removeItem("userRole");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // const otpLogin = async (mobileNumber) => {
  //   try {
  //     setError(null);
  //     setLoading(true);
  //     const response = await axios.post(`${BASE_URL}/otp-login`, {
  //       phoneNumber: mobileNumber,
  //     }, { withCredentials: true });

  //     if (response.status === 200) {
  //       // console.log("Login successful:", response.data); // ✅ Debugging
  //       setIsAuthenticated(true);
  //       return response.data; // ✅ Ensure correct return value
  //     }
  //   } catch (err) {
  //     setError(err.response?.data?.message || "Login failed");
  //     setIsAuthenticated(false);
  //     // setUserRole(null);
  //     // sessionStorage.removeItem("isAuthenticated");
  //     // sessionStorage.removeItem("userRole");
  //     throw err;
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const otpLogin = async (payload) => {
    try {
      setError(null);
      setLoading(true);

      const response = await axios.post(
        `${BASE_URL}/otp-login`,
        payload,
        { withCredentials: true }
      );

      if (response.status === 200) {
        setIsAuthenticated(true);
        return response; // return full response (recommended)
      }
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
      setIsAuthenticated(false);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await axios.post(`${BASE_URL}/logout`, {}, { withCredentials: true });
      setIsAuthenticated(false);
      // setUserRole(null);
      // ✅ Clear localStorage on logout
      // sessionStorage.clear();
    } catch (err) {
      console.error("Logout Error:", err);
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, otpLogin, logout, setIsAuthenticated, userRole, loading, setLoading, error }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
